import React, { RefObject } from 'react'
import { VisibleMessage, MessageAnimType } from '../Messages'
import {
  getElByUid,
  getMsgByType,
  getMessageSize,
  getWrapperPaddingBottom,
  getPrevMsg,
} from './utils'

export const animateNewAfterTypingCalc = (
  visibleMessages: VisibleMessage[],
  setVisibleMessages: React.Dispatch<React.SetStateAction<VisibleMessage[]>>,
  ref: RefObject<HTMLDivElement>
) => {
  const msg = getMsgByType(
    visibleMessages,
    MessageAnimType.NEW_AFTER_TYPING_CALC
  )
  const prevMsg = getPrevMsg(visibleMessages)

  if (!msg || !ref.current) {
    return
  }

  // console.log('NEW_AFTER_TYPING_CALC', msg);

  const [, height] = getMessageSize(ref, msg.uid)
  const [, prevHeight] = getMessageSize(ref, prevMsg.uid)

  const wrapperHeight = ref.current.offsetHeight
  const wrapperParentHeight = (ref.current.parentElement as HTMLDivElement)
    .offsetHeight
  const newWrapperHeight = wrapperHeight + height

  const move =
    newWrapperHeight > wrapperParentHeight
      ? Math.min(newWrapperHeight - wrapperParentHeight, height)
      : 0

  const bottomShift = -height + prevHeight + move + getWrapperPaddingBottom(ref)

  const prevBottomShift =
    newWrapperHeight > wrapperParentHeight
      ? 0
      : Math.min(wrapperParentHeight - newWrapperHeight, height)

  // console.log('NEW_AFTER_TYPING_CALC koniec', msg);

  setVisibleMessages(
    visibleMessages.map(m => {
      if (m.uid == msg.uid) {
        return {
          ...m,
          animType: MessageAnimType.NEW_AFTER_TYPING_ENTER,
          bottomShift,
        }
      }

      if (m.uid == prevMsg.uid) {
        return {
          ...m,
          animType: MessageAnimType.MOVE,
          translate: [0, prevBottomShift],
        }
      }

      return {
        ...m,
        animType: MessageAnimType.MOVE,
        translate: [0, -move],
      }
    })
  )
}

export const animateNewAfterTypingEnter = (
  visibleMessages: VisibleMessage[],
  setVisibleMessages: React.Dispatch<React.SetStateAction<VisibleMessage[]>>,
  setAnimating: React.Dispatch<React.SetStateAction<boolean>>,
  ref: RefObject<HTMLDivElement>,
  scrollToBottomOffset: () => void
) => {
  const msg = getMsgByType(
    visibleMessages,
    MessageAnimType.NEW_AFTER_TYPING_ENTER
  )

  if (!msg) {
    return
  }

  // console.log('NEW_AFTER_TYPING_ENTER', msg);

  const el = getElByUid(ref, msg.uid)

  if (!el) {
    return
  }

  const onEnd = () => {
    // console.log('NEW_AFTER_TYPING_ENTER koniec', msg);

    const mapped = visibleMessages.map(m => ({
      ...m,
      animType: MessageAnimType.NONE,
    }))

    const start = mapped.slice(0, -2)

    setVisibleMessages([
      ...start,
      mapped[mapped.length - 1],
      mapped[mapped.length - 2],
    ])

    setAnimating(false)
    scrollToBottomOffset()
    ;(el as HTMLDivElement).removeEventListener('animationend', onEnd)
  }

  ;(el as HTMLDivElement).addEventListener('animationend', onEnd)
}
